export default __webpack_public_path__ + "static/media/nn_book_cover.48d4c717.png";